import { useMemo, useState } from 'react';
import { Tooltip } from 'flowbite-react';
import { useParams } from 'react-router-dom';
import { MainDashboardLayoutComponent } from 'components/main-layout/main.component';
import { capitalize } from 'lodash';
import { BasicTableComponent } from 'components/table/table-basic.component';
import { BounceLoading } from 'components/loader/bounce.loading';
import { ModalConfirmation } from 'components/modal/moda.confirmation.component';
import { PATH_CONSTANT } from 'config/path.constant';
import { ModalResult } from 'components/modal/modal.result.component';
import { StandartImageComponent } from 'components/image/standart-image.component';
import { TableButtonExport } from 'components/table/table-button-export.component';
import {
  useLogBANEDProductDetails,
  useReportBANEDProductDetails,
} from 'api/report-ba/ned-product/ned-product.query.api';
import { useApproveNEDReport, useExportNEDDetailReport } from 'api/report-ba/ned-product/ned-product.mutation.api';
import { catchErrorMessage } from 'ui-utils/string.utils';

const BREAD_CUMB_ITEMS = [
  {
    title: 'Report BA',
    path: PATH_CONSTANT.REPORT_BA.NED_PRODUCT,
  },
  {
    title: 'NED Product',
    path: PATH_CONSTANT.REPORT_BA.NED_PRODUCT,
  },
  {
    title: 'Detail Page',
    path: null,
  },
];
const NED_DETAILS_STATUS_CLASSNAME = {
  submitted: 'inline-block bg-yellow rounded-md text-center w-28 py-1 px-1 rounded-sm text-white text-sm font-bold',
  approved: 'inline-block rounded-md bg-green text-center w-28 py-1 px-1 rounded-sm text-white text-sm font-medium',
};

export const NEDProductDetailsComponent = () => {
  const { recordId } = useParams();

  const [modals, setModals] = useState({
    export: false,
    updateStatus: false,
    result: false,
    attachment: false,
  });

  const { mutate: exportNEDDetailReport, isLoading: isExporting } = useExportNEDDetailReport();

  const { mutate: approveReport, isLoading: isApproving } = useApproveNEDReport();
  const { data: reportNEDDetails, isLoading, isError, error } = useReportBANEDProductDetails(recordId);
  const { data: logNEDDetails } = useLogBANEDProductDetails(recordId);

  const columns = useMemo(
    () => [
      {
        name: 'Product',
        className: 'w-[50%] text-sm font-semibold text-green text-center pr-3',
        dataIndex: 'user',
        render: (record) => (
          <div className='w-[50%] text-sm font-semibold text-green md:pr-1 pr-3'>
            <div class='flex items-center pl-2 xl:pl-5'>
              <div class='w-12'>
                <StandartImageComponent
                  src={record?.product_image || '/img/default-product.jpg'}
                  class='w-12 h-12 object-cover'
                  alt='Product'
                />
              </div>
              <div class='w-[calc(100%-3rem)] pl-3 xl:pl-5 line-clamp-3'>
                <Tooltip className='max-w-[30%]' content={record?.product_name}>
                  <div class='block text-xs font-semibold text-dark'>{record?.product_name}</div>
                </Tooltip>
              </div>
            </div>
          </div>
        ),
      },
      {
        name: 'Expired Date',
        className:
          'w-[30%] text-center text-sm font-semibold text-green overflow-hidden text-ellipsis whitespace-nowrap',
        dataIndex: 'expired_date_formatted',
        render: (record, expired_date_formatted) => (
          <div class='w-[30%]'>
            <div class='text-sm text-center font-medium  text-gray'>{expired_date_formatted}</div>
          </div>
        ),
      },

      {
        name: 'QTY',
        className:
          'w-[20%] text-sm font-semibold text-green overflow-hidden text-ellipsis whitespace-nowrap text-center',
        dataIndex: 'qty',
        render: (record, qty) => (
          <div class='w-[20%]'>
            <div class='text-sm font-medium text-center text-gray'>{qty}</div>
          </div>
        ),
      },
    ],
    []
  );

  const handleOnApproveReport = () => {
    approveReport(
      {
        ned_report_ids: [recordId],
      },
      {
        onSuccess: () => {
          setModals({ ...modals, updateStatus: false, result: true });
        },
      }
    );
  };
  const handleExport = () => {
    exportNEDDetailReport(
      { recordId },
      {
        onSuccess: (res) => {
          const link = document.createElement('a');
          link.href = res.data.download_url;
          document.body.appendChild(link);
          link.click();
          setModals({ ...modals, export: false });
        },
      }
    );
  };

  return (
    <MainDashboardLayoutComponent
      breadCumbs={BREAD_CUMB_ITEMS}
      isError={isError}
      errorTitle={error?.response?.data?.status}
      erroMessage={catchErrorMessage(error?.response?.data?.message)}
    >
      <div class='w-full flex items-center bg-gray-3 px-6 py-8 mb-5'>
        <div class='w-[calc(100%-430px)] border-r border-solid pr-5 border-green'>
          <div class='flex items-center'>
            <div class='w-[300px] flex items-center  '>
              <StandartImageComponent
                src={reportNEDDetails?.data?.user_image}
                class='overflow-hidden rounded-full w-[60px] h-[60px] border-2 border-solid border-green-3'
              />
              <div class='w-[calc(100%-3rem)] pl-3'>
                <div class='text-sm font-semibold text-green mb-2'>{reportNEDDetails?.data?.user_name}</div>
                <div class='overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium text-gray'>
                  {reportNEDDetails?.data?.user_phone}
                </div>
              </div>
            </div>
            <div class='w-[300px] flex items-center'>
              <StandartImageComponent
                defaultImage='/img/default-store.jpg'
                src={reportNEDDetails?.data?.store_image}
                class='overflow-hidden w-[60px] h-[60px] border-2 border-solid border-green-3'
              />
              <div class='w-[calc(100%-3rem)] pl-3'>
                <div class='overflow-hidden block text-ellipsis whitespace-nowrap text-sm font-semibold text-green mb-2'>
                  {reportNEDDetails?.data?.store_name}
                </div>
                <div class='overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium text-gray'>
                  {reportNEDDetails?.data?.store_city}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='w-[430px] pl-4 flex items-center justify-around'>
          <div class='flex w-full items-center justify-between'>
            <span class='icon-ico-calendar text-[30px] text-green-3 font-normal'></span>
            {reportNEDDetails?.data?.created_at_formatted && (
              <div class='w-[calc(100%-2rem)] pl-3'>
                <div class=' block  text-sm font-bold text-gray mb-2'>Tanggal Report</div>
                <div class='overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium text-gray'>
                  {reportNEDDetails?.data?.created_at_formatted}
                </div>
              </div>
            )}
          </div>
          <div class='flex w-full items-center justify-between'>
            <span class='icon-ico-info text-[30px] text-green-3 font-normal'></span>
            {reportNEDDetails?.data?.created_at_formatted && (
              <div class='w-[calc(100%-2rem)] pl-3'>
                <div class='overflow-hidden block text-ellipsis whitespace-nowrap text-sm font-bold text-gray mb-2'>
                  Status
                </div>
                <div className={NED_DETAILS_STATUS_CLASSNAME?.[reportNEDDetails?.data?.status]}>
                  {capitalize(reportNEDDetails?.data?.status)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className='h-[70vh] flex items-center'>
          <BounceLoading color='#5E755A' />
        </div>
      ) : (
        <>
          <div className='italic text-dark text-sm mb-5'>{`Total ${reportNEDDetails?.data?.report_items?.length} items`}</div>
          <div className='flex w-full justify-between pb-8'>
            <div className='w-[calc(100%-290px)]'>
              <BasicTableComponent
                rowClassName='flex items-center rounded-sm py-4 px-2 border border-solid border-transparent hover:border-green bg-white hover:bg-light-green transition duration-75 ease-in-out cursor-pointer'
                columns={columns}
                dataSource={reportNEDDetails?.data?.report_items || []}
              />
              <div class='bg-gray-1 mt-3 rounded-sm py-2.5 px-2 flex items-center'>
                <div class='w-[80%]'>
                  <div class='block text-sm font-bold text-dark uppercase pl-[10%] xl:pl-[8%]'>Total</div>
                </div>

                <div class='w-[20%] overflow-hidden'>
                  <div class='block text-sm font-bold text-dark uppercase text-center overflow-hidden text-ellipsis whitespace-nowrap'>
                    {reportNEDDetails?.data?.total_qty.toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
            <div class='w-[270px]'>
              <TableButtonExport
                onClick={handleExport}
                loading={isExporting}
                title='Export Data'
                className='outline-none w-full flex items-center border justify-center border-gray-1 rounded-sm hover:bg-light-green transition hover:border-green duration-150 ease-in-out border-solid py-1 px-3 mb-3'
              />

              <div class='border border-solid border-gray-1 rounded-sm p-2 mb-3'>
                <div class='block text-sm font-semibold text-dark mb-3'>Approvement Report</div>
                {reportNEDDetails?.data?.status === 'submitted' ? (
                  <button
                    class='bg-green flex justify-center items-center w-full hover:bg-dark-green transition duration-75 ease-in-out rounded-sm text-white py-2 font-semibold text-sm px-7'
                    type='button'
                    onClick={() => {
                      setModals((prev) => ({
                        ...prev,
                        updateStatus: true,
                      }));
                    }}
                  >
                    <span class='icon-ico-apply mr-3 text-lg'></span> Approve
                  </button>
                ) : (
                  <div className='text-green font-semibold'>
                    <span class='icon-ico-apply  text-sm text-center'></span> Approved
                  </div>
                )}
              </div>

              <div class='bg-gray-3 py-5 px-4 mb-3'>
                <div class='block text-sm font-semibold text-dark mb-6'>Log Action</div>

                <ul class='step max-h-[45vh] scroll'>
                  {logNEDDetails?.data?.map((actionLogItem) => (
                    <li>
                      <div class='bullet'></div>
                      <div class='text-sm font-semibold text-gray '>{actionLogItem?.action_description}</div>
                      <div class='text-xs font-semibold italic text-gray mb-2'>{`Modified by ${actionLogItem?.actor_email}`}</div>
                      <div class='text-sm font-medium italic text-gray'>{actionLogItem?.created_at_formatted}</div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </>
      )}

      <ModalConfirmation
        description='Apakah anda yakin ingin menyetujui data report ini ?'
        title='Approve Report'
        imageIcon='/img/info.svg'
        visible={modals.updateStatus}
        loading={isApproving}
        textConfirm='Approve'
        onConfirm={handleOnApproveReport}
        onClose={() => setModals({ ...modals, updateStatus: false })}
      />

      <ModalResult
        description='Data report berhasil di setujui!'
        title='Approve Report'
        visible={modals.result}
        textConfirm='OK'
        onConfirm={() => setModals({ ...modals, result: false })}
        onClose={() => setModals({ ...modals, result: false })}
      />
    </MainDashboardLayoutComponent>
  );
};
